import { FORUM_ARCHIVE_CAMPAIGNS_PAGE_TITLE, SEO_TITLE_FORUM_CAMPAIGN } from 'mk/autogenerated/translations/ArchivedCampaignsPage.dbab7dad9521a992a1045e1f3c7746da'
import { hasAds } from 'mk/bazaar/common/userUtils';
import ArchivedCampaigns from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns';
import { forumArchivedCampaignsLoad } from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.actions';
import archivedCampaignsReducer from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.reducers';
import archivedCampaignsSaga from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.sagas';
import {
    getArchivedCampaignsState,
    getArchivedCampaignsTopics,
} from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.selectors';
import { ArchivedCampaignsEntity } from 'mk2/apps/forum/schemas';
import { forumTopicsUrl } from 'mk2/apps/forum/urls';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { AnchorLeaderboardProps, BrandingProps, HalfpageProps } from 'mk2/pages/Page';
import { getRequestDeviceMobile, getRequestUser, AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
    className?: string;
}
interface StateProps {
    items: ArchivedCampaignsEntity[];
    loadingState: LoadingState;
    errorMessage: string;
    isMobile: boolean;
    requestUser: UserEntity;
}

interface DispatchProps {
    onLoad();
}

type RouteProps = RouteComponentProps<{}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class ArchivedCampaignsPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const archivedCampaignsState = getArchivedCampaignsState(state);

            return {
                errorMessage: archivedCampaignsState.errorMessage,
                loadingState: archivedCampaignsState.loadingState,
                items: getArchivedCampaignsTopics(state),
                isMobile: getRequestDeviceMobile(state),
                requestUser: getRequestUser(state),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: forumArchivedCampaignsLoad,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_FORUM_CAMPAIGN;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <ArchivedCampaigns {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return forumTopicsUrl;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return {
            zone: 'Forum Category - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        return {
            zone: 'Forum - Branding',
        };
    }

    public getAnchorLeaderboardProps(props: Props): AnchorLeaderboardProps {
        const { requestUser, isMobile, items } = props;

        if (!isMobile || requestUser && !hasAds(requestUser)) {
            return null;
        }

        if (!items || items.length < 20) {
            return null;
        }

        return {
            zone: 'Forum Category - Anchor Ad Leaderboard (Mobile)',
        };
    }

    public getHeaderTitle(props: Props): string {
        return FORUM_ARCHIVE_CAMPAIGNS_PAGE_TITLE;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.forum.forumArchivedCampaigns', archivedCampaignsReducer);
        store.injectSaga('containers.forum.forumArchivedCampaigns', archivedCampaignsSaga);
    }

}
